<template>
  <div class="bq-coo">
    <div class="bq-coo-wrap">
      <div class="bq-coo-left">
        <p class="left">市场渠道合作</p>
        <el-button round @click="handleClick('2')">详情</el-button>
      </div>
      <img
        src="https://img.alicdn.com/tfs/TB1Avw6CAT2gK0jSZFkXXcIQFXa-1140-672.png"
        alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
      />
    </div>
    <div class="bq-coo-wrap">
      <img
        src="https://img.alicdn.com/tfs/TB1R9o4CxD1gK0jSZFKXXcJrVXa-1140-672.png"
        alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
      />
      <div class="bq-coo-left tr">
        <p class="right">孵化器入驻咨询</p>
        <el-button round @click="handleClick('1')">详情</el-button>
      </div>
    </div>
    <div class="bq-coo-map">
      <div id="container"></div>
      <div class="bq-coo-address">
        <p>
          联系邮箱：<a href="mailto:jkbianque@aliyun.com"
            >jkbianque@aliyun.com</a
          >
        </p>
        <p>
          公司地址：浙江省杭州市余杭区文一西路和绿汀路交叉口浙富西溪堂1号楼
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Coo',
  methods: {
    handleClick(type) {
      if (type === '1') {
        this.$router.push('cooperation');
      } else {
        this.$router.push('settledin');
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bq-coo {
  padding-top: 90px;
  .bq-coo-wrap {
    width: 1020px;
    margin: 0 auto;
    margin-bottom: 90px;
    display: flex;
    justify-content: space-between;

    .tr {
      text-align: center;
    }

    .bq-coo-left {
      width: 450px;
      p {
        margin: 96px 0 60px 112px;
        color: #0d3091;
        font-size: 24px;
        position: relative;
        &::before {
          content: '';
          display: block;
          position: absolute;
          width: 57px;
          height: 57px;
          border-radius: 50%;
          background: rgba(17, 72, 225, 0.1);
        }

        &.left {
          &::before {
            left: -17px;
            top: -10px;
          }
        }

        &.right {
          &::before {
            right: 67px;
            top: -10px;
          }
        }
      }

      /deep/ .el-button {
        margin-left: 103px;
        width: 170px;
        height: 52px;
        background-color: #fff;
        border-radius: 31px;
        border: 1px solid #0d3091;
        color: #0d3091;
        font-size: 18px;
        transition: all 0.3s ease;
        span {
          width: 66px;
          display: inline-block;
          text-align: center;
          letter-spacing: 30px;
        }

        &:hover {
          color: #fff;
          background-color: #0d3091;
          border-color: #0d3091;
        }
      }
    }

    img {
      width: 570px;
      height: 366px;
    }
  }
  .bq-coo-map {
    height: 440px;
    display: flex;
    background-color: rgba(216, 216, 216, 0.2);
    align-items: center;
    justify-content: center;

    #container {
      width: 520px;
      height: 329px;
      margin-right: 77px;
      border-radius: 10px;
      border: 2px solid rgba(255, 255, 255, 1);
    }

    .bq-coo-address {
      color: #333;
      font-size: 18px;
      p:nth-child(1) {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
